import React, { Component } from 'react';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

export default class ScreenWrapper extends Component {
  render() {
    return <ErrorBoundary>{this.props.children}</ErrorBoundary>;
  }
}
